var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6507 7.44073H25.1174L20.6107 2.93406C20.2507 2.57406 19.6641 2.57406 19.2907 2.93406C18.9307 3.29406 18.9307 3.88073 19.2907 4.25406L22.4774 7.44073H9.5174L12.7041 4.25406C13.0641 3.89406 13.0641 3.3074 12.7041 2.93406C12.3441 2.57406 11.7574 2.57406 11.3841 2.93406L6.89073 7.44073H6.3574C5.1574 7.44073 2.66406 7.44073 2.66406 10.8541C2.66406 12.1474 2.93073 13.0007 3.49073 13.5607C3.81073 13.8941 4.1974 14.0674 4.61073 14.1607C4.9974 14.2541 5.41073 14.2674 5.81073 14.2674H26.1841C26.5974 14.2674 26.9841 14.2407 27.3574 14.1607C28.4774 13.8941 29.3307 13.0941 29.3307 10.8541C29.3307 7.44073 26.8374 7.44073 25.6507 7.44073Z",
    fill: "#E5A240"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4009 16H6.49419C5.66752 16 5.04086 16.7333 5.17419 17.5467L6.29419 24.4C6.66752 26.6933 7.66752 29.3333 12.1075 29.3333H19.5875C24.0809 29.3333 24.8809 27.08 25.3609 24.56L26.7075 17.5867C26.8675 16.76 26.2409 16 25.4009 16ZM16.0009 26C12.8809 26 10.3342 23.4533 10.3342 20.3333C10.3342 19.7867 10.7875 19.3333 11.3342 19.3333C11.8809 19.3333 12.3342 19.7867 12.3342 20.3333C12.3342 22.36 13.9742 24 16.0009 24C18.0275 24 19.6675 22.36 19.6675 20.3333C19.6675 19.7867 20.1209 19.3333 20.6675 19.3333C21.2142 19.3333 21.6675 19.7867 21.6675 20.3333C21.6675 23.4533 19.1209 26 16.0009 26Z",
    fill: "#E5A240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagHappy);
export default __webpack_public_path__ + "static/media/bag-happy.aa49621bceabc4b0433cd54e46a1428e.svg";
export { ForwardRef as ReactComponent };